var FinalizationRegistryLocal = typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry;
export { FinalizationRegistryLocal as FinalizationRegistry };